import { resize } from './utils/ai2html-resizer';

resize('#g-western_aquifers-box');
